import FaqSection from "../components/FaqSection";
import ContactRequest from "@/components/Contact/ContactRequest";
import ContactHero from "../components/Contact/ContactHero";

const Contact = () => {
  return (
    <>
      <ContactRequest />
      <FaqSection />
      {/* <ContactHero /> */}
    </>
  );
};

export default Contact;
